import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import type { KioskScanLayout } from "../kioskLayout"
import KioskPreviewScanBackButton from "./KioskPreviewScanBackButton"

type Props = {
  layout: KioskScanLayout["header"]
  title: string
  logoUrl: string
}

/**
 * Scan header — black @ 62%, anchored to the top and extending up through the status bar.
 * A centered logo/title stack sits in the safe content area; the back button is pinned to
 * the leading edge, vertically centered with the stack.
 */
const KioskPreviewScanHeader = ({ layout, title, logoUrl }: Props) => (
  <Box position="absolute" top={0} left={0} w="100%" h={`${layout.barHeight}px`} bg="rgba(0, 0, 0, 0.62)">
    <Box
      position="absolute"
      left={`${layout.sideMargin}px`}
      top={`${layout.back.centerY - layout.back.glyphPx / 2}px`}
    >
      <KioskPreviewScanBackButton glyphPx={layout.back.glyphPx} />
    </Box>

    <Flex
      position="absolute"
      top={`${layout.contentTop}px`}
      left={0}
      w="100%"
      h={`${layout.stackHeight}px`}
      direction="column"
      align="center"
      justify="center"
    >
      {layout.hasLogo && logoUrl && (
        <Box
          as="img"
          src={logoUrl}
          alt="Brand Logo"
          h={`${layout.logoHeight}px`}
          maxW="60%"
          objectFit="contain"
          mb={layout.hasTitle ? `${layout.gap}px` : 0}
        />
      )}
      {layout.hasTitle && (
        <Text
          fontSize={`${layout.titleFontPx}px`}
          fontWeight="medium"
          color="white"
          lineHeight={1.05}
          letterSpacing="tight"
          textAlign="center"
          noOfLines={1}
          maxW="70%"
        >
          {title}
        </Text>
      )}
    </Flex>
  </Box>
)

export default KioskPreviewScanHeader
